/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Timeslot } from './Timeslot';
import {
    TimeslotFromJSON,
    TimeslotFromJSONTyped,
    TimeslotToJSON,
} from './Timeslot';
import type { ClaimCenterWithBookables } from './ClaimCenterWithBookables';
import {
    ClaimCenterWithBookablesFromJSON,
    ClaimCenterWithBookablesFromJSONTyped,
    ClaimCenterWithBookablesToJSON,
} from './ClaimCenterWithBookables';

/**
 * Availability timeslots for a claim center on a specific date
 * @export
 * @interface ClaimCenterAvailability
 */
export interface ClaimCenterAvailability {
    /**
     * 
     * @type {Array<Timeslot>}
     * @memberof ClaimCenterAvailability
     */
    timeslots: Array<Timeslot>;
    /**
     * 
     * @type {ClaimCenterWithBookables}
     * @memberof ClaimCenterAvailability
     */
    claimCenter: ClaimCenterWithBookables;
}

/**
 * Check if a given object implements the ClaimCenterAvailability interface.
 */
export function instanceOfClaimCenterAvailability(value: object): value is ClaimCenterAvailability {
    if (!('timeslots' in value) || value['timeslots'] === undefined) return false;
    if (!('claimCenter' in value) || value['claimCenter'] === undefined) return false;
    return true;
}

export function ClaimCenterAvailabilityFromJSON(json: any): ClaimCenterAvailability {
    return ClaimCenterAvailabilityFromJSONTyped(json, false);
}

export function ClaimCenterAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'timeslots': ((json['timeslots'] as Array<any>).map(TimeslotFromJSON)),
        'claimCenter': ClaimCenterWithBookablesFromJSON(json['claimCenter']),
    };
}

export function ClaimCenterAvailabilityToJSON(value?: ClaimCenterAvailability | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timeslots': ((value['timeslots'] as Array<any>).map(TimeslotToJSON)),
        'claimCenter': ClaimCenterWithBookablesToJSON(value['claimCenter']),
    };
}

